module.exports = __webpack_public_path__ + "static/media/LCV1_edited.6b00f2f3.png";